export const isWalletFeatureEnabled = true;
export const isCashbackFeatureEnabled = true;
export const isTopUpWalletEnabled = false;
